import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Eye, Pencil, Plus, Trash } from "@phosphor-icons/react";
import { t } from "i18next";
import WidgetsArrayFieldTemplate from "./templates/WidgetsArrayFieldTemplate";

const config = {
  modelName: "custom-report",
  modelPluralName: "custom-reports",
  endpoint: "custom-reports",
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.DETAILS,
        label: "details",
        icon: <Eye size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "name",
        label: "name",
        key: "name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "start_date",
        label: "start_date",
        key: "start_date",
        type: "date",
        show: true,
        allowOrder: true,
      },
      {
        name: "end_date",
        label: "end_date",
        key: "end_date",
        type: "date",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {

    type: "object",
    properties: {
      // Name
      name: {
        type: "string",
        title: t("name"),
      },
      start_date: {
        type: "string",
        title: t("start_date"),
        format: "date",          
        default: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
      },
      end_date: {
        type: "string",
        title: t("end_date"),
        format: "date",
        default: new Date().toISOString().split('T')[0],
      },

      widgets: {
        type: "array",
        title: t("widgets"),
        items: {
          type: "object",
          title: '',
          properties: {
            name: {
              type: "string",
              title: t("name"),
            },
            measure: {
              type: "string",              
              title: t("measure"),
              oneOf: [
                {
                  const: "reservas",            
                  title: "Reservas",
                },
                {
                  const: "facturacion",           
                  title: "Facturación",
                },
                {
                  const: "cancelaciones",      
                  title: "Cancelaciones",
                },
                {
                  const: "extras",             
                  title: "Extras",
                },
                {
                  const: "reseñas",           
                  title: "Reseñas",
                },
                {
                  const: "altas_clientes",    
                  title: "Altas de Clientes",
                },
              ]
            },
            type: {
              type: "string",              
              title: t("type"),
              oneOf: [
                {
                  const: "suma",
                  title: "Suma",
                },
                {
                  const: "media",
                  title: "Media",
                },
                {
                  const: "grafico",
                  title: "Gráfico",
                },
              ]
            },
          },
        },
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    widgets: {
      "ui:ArrayFieldTemplate": WidgetsArrayFieldTemplate,
      items: {
        colsSchema: [
          {
            cols: "col-12",
            elements: [
              [
                {
                  name: "name",
                  cols: "col-6",
                },
                {
                  name: "measure",
                  cols: "col-6",
                },
                {
                  name: "type",
                  cols: "col-6",
                },
                {
                  name: "period",
                  cols: "col-6",
                }
              ],
              
            ],
          }
        ]
      }
    }
  },
};
export default config;
